import { render, staticRenderFns } from "./Header.vue?vue&type=template&id=5ec0602c&scoped=true&"
import script from "./Header.vue?vue&type=script&lang=js&"
export * from "./Header.vue?vue&type=script&lang=js&"
import style0 from "./Header.vue?vue&type=style&index=0&id=5ec0602c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ec0602c",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {HeaderMobile: require('D:/xtdt-qna-fe/components/Header/HeaderMobile.vue').default})
